<template>
  <div id="page-homeapproval" class="d-flex">
    <MainBarMenu />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="page-approval py-3">
        <div class="container">
          <p class="title-1 mb-0 mt-5 pt-5">
            SOLICITUD PERMISO SINDICAL - {{ this.$route.params.id }}
          </p>

          <div class="row">
            <template v-if="processing">
              <b-col cols="12" class="text-center">
                <div class="position-fixed" id="loader"/>
              </b-col>
            </template>
            <template v-else>
              <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                <div
                  class="cont-approval-text d-flex flex-column justify-content-around mt-0 mt-md-1"
                >
                  <!-- .cont-title -->
                  <form
                    action="#"
                    class="form-approval mt-5 mb-5 mb-md-5 d-flex flex-column flex-md-row align-items-center"
                  >
                    <div v-if="loading" id="loader"></div>
                    <div v-else role="tablist">
                      <div v-show="!this.tktsValidate">
                        <b-alert show variant="danger">
                          <b align="center"
                            >Esta solicitud no tiene tiquetes para aprobar</b
                          >
                        </b-alert>
                      </div>
                      <div v-show="this.tktsValidate">
                        <table class="tabla2">
                          <thead>
                            <tr>
                              <th class="td1" rowspan="3">
                                INFORMACIÓN DE TIQUETES:
                              </th>
                              <th class="td2">Destino</th>
                              <th class="td2">Ida sugerida</th>
                              <th class="td2">Vuelta sugerida</th>
                            </tr>
                            <tr>
                              <td class="td3">{{ this.horaIda }}</td>
                              <td class="td3">{{ this.horaRegreso }}</td>
                              <td class="td3">{{ this.destino }}</td>
                            </tr>
                            <tr>
                              <td class="td3" colspan="3">
                                Ver fechas individualizadas en la carta de
                                aprobación
                              </td>
                            </tr>
                          </thead>
                        </table>
                        <b-card
                          no-body
                          class="mb-1"
                          style="width: 500px !important"
                        >
                          <b-card-header
                            header-tag="header"
                            class="p-1"
                            role="tab"
                          >
                            <b-button
                              class="button1"
                              block
                              v-b-toggle.accordion-1
                              variant="info"
                            >
                              1. Carga de tiquetes
                              <span class="when-opened">
                                <img
                                  class="centerImg1"
                                  src="@/assets/images/icons/chevron-up.svg"
                                />
                              </span>
                              <span class="when-closed">
                                <img
                                  class="centerImg1"
                                  src="@/assets/images/icons/chevron-down.svg"
                                />
                              </span>
                            </b-button>
                          </b-card-header>
  
                          <b-collapse
                            id="accordion-1"
                            visible
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body class="px-5">
                              <b-table :items="filas" :fields="campos" hover>
                                <template v-slot:cell(Tiquetes)="row">
                                  <div
                                    v-show="
                                      validateDaysApprovals[row.item.id] > 0
                                    "
                                    class="row"
                                  >
                                    <div class="col-12 text-center">
                                      <div v-if="user.core_role_id === 7">
                                        <b-form-radio-group
                                          id="btn-radios-2"
                                          v-model="listApproveTkt[row.item.id]"
                                          buttons
                                        >
                                          <b-form-radio
                                            v-for="option in opcion"
                                            :key="option.text"
                                            :value="option.value"
                                            :button-variant="option.variant"
                                            @change="approveTkt(row, $event)"
                                          >
                                            {{ option.text }}
                                          </b-form-radio>
                                        </b-form-radio-group>
                                      </div>
                                      <div v-else>
                                        {{ listApproveTkt[row.item.id] }}
                                      </div>
                                      <!--b-form-radio-group
                                          id="btn-radios-2"
                                          v-model="listApproveTkt[row.item.id]"
                                          :options="opcion"
                                          buttons
                                          button-variant="outline-primary"
                                          size="sm"
                                          @change="approveTkt(row,$event)"
                                        ></b-form-radio-group-->
                                      <!--div class="col-12 text-center"> name="radio-btn-outline"
                                        <label class="switch">
                                          <input type="checkbox"
                                            v-model="listApproveTkt[row.item.id]"
                                            @change="approveTkt(row)">
                                          <span class="slider round"></span>
                                        </label-->
                                    </div>
                                  </div>
                                </template>
                                <template v-slot:cell(Acciones)="row">
                                  <div
                                    v-if="validateDaysApprovals[row.item.id] > 0"
                                    class="row"
                                  >
                                    <div class="col-6 text-right">
                                      <label
                                        class="custom-file-upload"
                                        v-show="
                                          listApproveTkt[row.item.id] ===
                                            'Aprobado' && user.core_role_id === 7
                                        "
                                      >
                                        <input
                                          type="file"
                                          :id="'tkt' + row.item.Tiquetes"
                                          :name="row.item.Tiquetes"
                                          @change="uploadTkt(row)"
                                        />
                                        <p class="td4">
                                          <img
                                            class="img1"
                                            src="@/assets/images/icons/up.svg"
                                          />
                                          Cargar
                                        </p>
                                      </label>
                                    </div>
                                    <div
                                      class="col-6 text-left"
                                      v-show="
                                        listFilesTkt[row.item.id] &&
                                        listApproveTkt[row.item.id] === 'Aprobado'
                                      "
                                    >
                                      <a
                                        target="_blank"
                                        :href="
                                          serverPath +
                                          '/' +
                                          listFilesTkt[row.item.id]
                                        "
                                      >
                                        <p class="td4">
                                          <img
                                            class="img1"
                                            src="@/assets/images/icons/clip.svg"
                                          />
                                          Ver
                                        </p>
                                      </a>
                                    </div>
                                  </div>
                                  <div v-else>Permiso no aprobado</div>
                                </template>
                              </b-table>
                            </b-card-body>
                          </b-collapse>
  
                          <!--b-card-header header-tag="header" class="p-1" role="tab">
                              <b-button class="button1" block v-b-toggle.accordion-2 variant="info">                              
                                2. Comentarios
                                <span class="when-opened">                            
                                  <img class="centerImg1" src="@/assets/images/icons/chevron-up.svg">
                                </span>
                                <span class="when-closed">                            
                                  <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                                </span>
                              </b-button>
                            </b-card-header>
                            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                              <b-card-body class="px-5">
                                <b-card-text>    
                                  <div class="row">                 
                                    <div class="col-12 mb-md-1">
                                      <textarea class="form-control"
                                        v-model="comentario"
                                        placeholder="Ingresar comentario..."               
                                        ref="input"
                                        rows="5">
                                      </textarea>
                                    </div>
                                  </div>
                                  <div class="row" align="right">
                                    <div class="col-12 mb-md-5">                                    
                                      <button 
                                          type="button"
                                          class="btn btn-darkblue-1"
                                          v-on:click="updateComment()">
                                        Guardar
                                      </button>
                                    </div>
                                  </div>
                                  <div class="content scrollable">
                                    <div 
                                      v-for="comment in this.comments.slice().reverse()" 
                                      :key="comment.id">
                                      <div class="row">                                      
                                        <div class="col-9 mb-md-0">
                                          <p class="td5"><b>{{comment.core_employee.name}}</b>-({{comment.core_employee.core_role.name}})</p>
                                        </div>
                                        <div class="col-3 mb-md-0" align="right">
                                          <p class="p1">{{formatDateShow(comment.created_at)}}</p>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 mb-md-0"  align="left">
                                          <p class="td5">{{comment.text}}</p>
                                          <img src="@/assets/images/icons/bar.svg">
                                        </div>
                                      </div>                                    
                                    </div>                                  
                                  </div>
                                </b-card-text>                  
                              </b-card-body>
                            </b-collapse-->
                        </b-card>
                        <div class="row">
                          <div class="col-12 pt-5" align="center">
                            <small v-show="error.flag" class="alert-danger">
                              <b align="center">{{ error.message }}</b>
                            </small>
                            <small v-show="success.flag" class="alert-heading">
                              <b-alert show variant="success">
                                <strong>{{ success.message }}</strong>
                              </b-alert>
                            </small>
                          </div>
                        </div>
                        <div class="row" align="center">
                          <div class="col-12 text-center">
                            <small
                              v-show="
                                diffDate > 0 &&
                                diffDate <= this.nationalDays &&
                                this.tktsValidate == 1 &&
                                this.type == 'Nacional'
                              "
                            >
                              <b-alert show variant="danger">
                                ATENCIÓN: Este tiquete nacional fue solicitado con
                                menos de {{ this.nationalDays }} días de
                                anticipación.
                              </b-alert>
                            </small>
                            <small
                              v-show="
                                diffDate > 0 &&
                                diffDate <= this.internationalDays &&
                                this.tktsValidate == 1 &&
                                this.type == 'Internacional'
                              "
                            >
                              <b-alert show variant="danger">
                                ATENCIÓN: Este tiquete Internacional fue
                                solicitado con menos de
                                {{ this.internationalDays }} días de anticipación.
                              </b-alert>
                            </small>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 text-center">
                            <small v-show="cityValidation == true">
                              <b-alert show variant="warning">
                                Recuerda gestionar los traslados terrestres para
                                los colaboradores de Tocancipá.
                              </b-alert>
                            </small>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 pt-5" align="center">
                            <router-link to="/solicitudes">
                              <button class="button2">Volver</button>
                            </router-link>
                          </div>
                        </div>
                        <small v-show="error.flag" class="alert-danger">{{
                          error.message
                        }}</small>
                      </div>
                    </div>
                  </form>
                </div>
                <div>
                  <b-modal
                    ref="my-modal"
                    hide-footer
                    centered
                    title="Atención al mensaje:"
                    no-close-on-backdrop
                    @hidden="hideModal"
                  >
                    <div class="d-block text-center">
                      <h3>{{ this.msjModal }}</h3>
                    </div>
                    <b-button
                      class="mt-3"
                      variant="outline-danger"
                      block
                      @click="hideModal"
                    >
                      Cerrar
                    </b-button>
                  </b-modal>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                <letter-template :dataAvailableTickets="dataAvailableTickets" />
              </div>
            </template>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
// import TemplateLetter from "./TemplateLetter.vue";
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "HomeApproval",
  components: {
    MainBarMenu,
    HeadingUser,
    letterTemplate: () =>
      import(
        "@/components/Modules/PermisosSindicales/License/Letters/Letter.vue"
      ),
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      cityValidation: false,
      processing: true,
      validateDaysApprovals: [],
      keyComponent: 0,
      tktsValidate: "",
      bp: "",
      fechaIni: "",
      type: "",
      comments: [],
      comentario: "",
      horaIda: "",
      horaRegreso: "",
      destino: "",
      infoAdicional: "",
      img1: "circle-clock.svg",
      img2: "circle-clock.svg",
      charge: "",
      listApproveTkt: [],
      listFilesTkt: [],
      msjModal: "",
      flagPath: 0,
      campos: [
        { key: "Colaboradores", class: "text-left" },
        { key: "Origen", class: "text-center" },
        { key: "Tiquetes", class: "text-center" },
        { key: "Acciones", class: "text-center" },
      ],
      filas: [],
      //seleccion: 'radio1',
      opcion: [
        { text: "No", value: "Rechazado", variant: "outline-danger" },
        { text: "-", value: "Pendiente", variant: "outline-warning" },
        { text: "Si", value: "Aprobado", variant: "outline-success" },
      ],
      monthNames: [
        "cero",
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      nationalDays: 0,
      internationalDays: 0,
      dataAvailableTickets: null,
    };
  },
  beforeMount() {
    this.processing = true
    const license_id = this.$route.params.id;
    this.actGetRequest(license_id)
      .then(() => {
        this.dataAvailableTickets = {
          society_id: this.request.data.license.petitioner_society.id,
          startDate: this.request.data.license.startDate,
        };
        this.loadRows();

        this.tktsValidate = this.request.data.license.tickets;
        this.horaIda =
          this.request.data.license.license_employees[0].ticket.destination;
        this.horaRegreso =
          this.request.data.license.license_employees[0].ticket.departureTime;
        this.destino =
          this.request.data.license.license_employees[0].ticket.returnTime;
        this.type = this.request.data.license.license_employees[0].ticket.type;
        this.comments = this.request.data.license.lic_comments;
        this.fechaIni = this.request.data.license.startDate;
        this.getTraceabilityAction({ id: license_id });
      })
      .catch((response) => {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message = "No se pudo conectar al servicio: " + response;
      }).finally(() => this.processing = false);

    this.actGetSettings().then(() => {
      this.nationalDays = this.settings.data.national_tickets_days;
      this.internationalDays = this.settings.data.international_tickets_days;
    });
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modRequest", ["request", "loading", "settings"]),
    ...mapState("modApproval", ["loading"]),

    diffDate: function () {
      let currentDay = new Date();
      let fechaInitial = this.fechaIni ? new Date(this.fechaIni) : currentDay;
      var timeDiff = Math.abs(fechaInitial.getTime() - currentDay.getTime());
      return Math.ceil(timeDiff / (1000 * 3600 * 24));
    },
  },
  methods: {
    ...mapActions("modApproval", ["actSaveTktApproval", "actSaveTktFile"]),
    ...mapActions("modRequest", [
      "actGetRequest",
      "actSaveComments",
      "actGetSettings",
    ]),
    ...mapActions("permisosSindicalesV2License", [
      "getTraceabilityAction",
    ]),

    loadRows() {
      this.filas = [];
      for (
        let i = 0;
        i < this.request.data.license.license_employees.length;
        i++
      ) {
        this.validateDaysApprovals[i] = 0;
        this.filas.push({
          id: i,
          Colaboradores:
            this.request.data.license.license_employees[i].core_employee.name,
          Origen:
            this.request.data.license.license_employees[i].ticket.origin_city
              .name,
          Tiquetes: this.request.data.license.license_employees[i].ticket_id,
          estado: this.request.data.license.license_employees[i].ticket.status, // == 'approved') ? 'Aprobado' : (this.request.data.license.license_employees[i].ticket.status == 'rejected') ? 'Rechazado' : 'Pendiente',
          archivo: this.request.data.license.license_employees[i].ticket.image,
        });
        if (
          this.request.data.license.license_employees[i].ticket.origin ==
          "Tocancipá"
        ) {
          this.cityValidation = true;
        }
        this.listApproveTkt[i] =
          this.request.data.license.license_employees[i].ticket.status ==
          "pending"
            ? "Pendiente"
            : this.request.data.license.license_employees[i].ticket.status ==
              "approved"
            ? "Aprobado"
            : "Rechazado";
        this.listFilesTkt[i] = this.request.data.license.license_employees[i]
          .ticket.image
          ? this.request.data.license.license_employees[i].ticket.image
          : null;

        for (
          let j = 0;
          j < this.request.data.license.license_employees[i].days.length;
          j++
        ) {
          if (
            this.request.data.license.license_employees[i].days[j].status ==
            "approved"
          ) {
            this.validateDaysApprovals[i] += 1;
          }
        }
      }
    },

    approveTkt(row, event) {
      //alert(event);
      let data = [];
      let msjEstado = event; //(event == "approved" ) ? "Aprobado" : (event == "rejected" ) ? "Rechazado" : 'Pendiente';
      let estadoTkt =
        event == "Aprobado"
          ? "approved"
          : event == "Rechazado"
          ? "rejected"
          : "pending";
      data[0] = row.item.Tiquetes;
      data[1] = { status: estadoTkt };

      this.actSaveTktApproval(data)
        .then(() => {
          this.actGetRequest(this.$route.params.id)
            .then(() => {
              this.loadRows();
            })
            .catch(() => {
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message = "No se pudo conectar al servicio";
            });
          this.success.flag = true;
          this.success.class = "is-valid";
          this.success.message =
            "El tiquete de: " + row.item.Colaboradores + " quedó " + msjEstado;
          //his.listFilesTkt[row.item.id] = "";
        })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "Ocurrio un error al guardar por favor actualizar la pagina: " +
            response;
        });
      //}
    },

    uploadTkt(row) {
      //alert(JSON.stringify(row));
      var data = [];
      var formData = new FormData();
      var validator = "#tkt" + row.item.Tiquetes;
      var fileTkt = document.querySelector(validator);
      formData.append("file", fileTkt.files[0]);

      data[0] = row.item.Tiquetes;
      data[1] = formData;

      this.actSaveTktFile(data)
        .then(() => {
          this.success.flag = true;
          this.success.class = "is-valid";
          this.success.message =
            "El archivo de: " + row.item.Colaboradores + " quedó guardado";

          this.actGetRequest(this.$route.params.id)
            .then(() => {
              this.loadRows();
            })
            .catch(() => {
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message = "No se pudo conectar al servicio";
            });
        })
        .catch(() => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "Ocurrio un error al guardar por favor actualizar la pagina.";
        });
    },

    updateComment() {
      if (this.comentario) {
        let data = "";
        data = {
          license_id: this.$route.params.id,
          core_employee_id: this.user.id,
          text: this.comentario,
        };
        //alert(JSON.stringify(data));

        this.actSaveComments(data)
          .then(() => {
            this.success.flag = true;
            this.success.class = "is-valid";
            this.success.message = "El comentario quedó guardado";

            this.actGetRequest(this.$route.params.id)
              .then(() => {
                this.comments = this.request.data.license.lic_comments;
              })
              .catch(() => {
                this.error.flag = true;
                this.error.class = "is-invalid";
                this.error.message = "No se pudo conectar al servicio";
              });
            this.comentario = "";
          })
          .catch(() => {
            this.error.flag = true;
            this.error.class = "is-invalid";
            this.error.message =
              "Ocurrio un error al guardar por favor actualizar la pagina.";
          });
      } else {
        this.showModal("Debe ingresar un comentario", 0);
      }
    },

    formatDateShow(date) {
      var d = new Date(date);
      var datestring =
        d.getDate() +
        " " +
        this.monthNames[d.getMonth() + 1] +
        " " +
        d.getFullYear();
      return datestring;
    },

    showModal(msj, flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
      if (this.flagPath == 1) {
        this.$router.push({ path: "/solicitudes" });
      }
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans&display=swap");
.page-approval {
  .title-1 {
    font-size: 24px;
    font-weight: bold;
    color: #1c3a4e;
  }
  .cont-approval-text {
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 20px;
        font-weight: bold;
        color: #1c3a4e;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-approval {
      .form-group-req {
        input[type="text"] {
          height: 32px;
          border: 1px solid #454545;
          border-radius: 4px;
          padding: 0 10px;
        }
      }
      .button1 {
        font-family: "Open Sans";
        background: #e9ecee;
        color: #1c3a4e;
        font-weight: bold;
        //border-radius: 50px;
        height: 32px;
        font-size: 14px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        outline: none;
        border: none;
        &:hover {
          background: darken(#cddce6, 5);
          border: none;
        }
      }
      .button2 {
        background: #1c3a4e;
        color: #ffffff;
        border-radius: 50px;
        height: 32px;
        font-size: 16px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        &:hover {
          background: darken(#cddce6, 5);
        }
      }
      .button3 {
        border: none;
        background-color: inherit;
        padding: 5px 10px;
        font-size: 11px;
        cursor: pointer;
        display: inline-block;
        text-decoration: underline;
      }
      .button4 {
        background: #99a6af;
        color: #ffffff;
        border-radius: 8px;
        height: 32px;
        font-size: 16px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        &:hover {
          background: darken(#99a6af, 5);
        }
      }
      .button2:hover {
        background: #eee;
      }
      .default {
        color: black;
      }
    }
  }
  .tr1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
    padding-left: 5%;
  }
  .td1 {
    background: #1c3a4e;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
  }
  .td2 {
    background: #ffffff;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;
    width: 95px;
    text-align: center;
  }
  .td3 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 25px;
    text-align: center;
  }
  .td4 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
  }
  .td5 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 12px;
  }
  .tabla2 {
    border-radius: 5px;
    border: 3px solid #1c3a4e;
    border-color: #1c3a4e;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 500px;
  }
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
  .img1 {
    width: 18px;
    height: 18px;
    left: 100%;
    top: 100%;
    float: center;
  }
  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }
  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: green;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px green;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
  .custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 1px 2px;
    cursor: pointer;
  }
  input[type="file"] {
    display: none;
  }
  .scrollable {
    overflow: hidden;
    overflow-y: scroll;
    height: calc(30vh - 20px);
  }
}
</style>
